// @flow

import createAction from 'redux-actions/lib/createAction';

// -----------------------------------------------------------------------------------------------------------------
// Types
// -----------------------------------------------------------------------------------------------------------------

type ResetAllDataActionType = 'RESET_ALL_DATA';

type ResetAllDataAction = { type: ResetAllDataActionType };


// -----------------------------------------------------------------------------------------------------------------
// Actions
// -----------------------------------------------------------------------------------------------------------------

const resetAllData: () => ResetAllDataAction = createAction(('RESET_ALL_DATA': ResetAllDataActionType));


// -----------------------------------------------------------------------------------------------------------------
// Exports
// -----------------------------------------------------------------------------------------------------------------

export default resetAllData;


// WEBPACK FOOTER //
// ./src/actions/resetAllData.js